const aboutUsContent = [
	{
		quote: "To portal, gdzie możesz naprawdę poczuć się sobą i nie wstydzić się swoich pragnień, tu nie ma tematów tabu.",
		link: "https://www.se.pl/zdrowie/jednorazowa-przygoda-czy-dluzszy-zwiazek-aa-fsmp-WvS5-6zxC.html",
		linkName: "Jednorazowa przygoda czy dłuższy związek?",
		data: "07.11.2018",
		author: "Super Express",
	},
	{
		quote: "Najczęściej odwiedzaną witryną przeznaczoną tylko dla dorosłych jest Datezone.com, serwis randkowy pozwalający znaleźć dziki i niezobowiązujący seks.",
		link: "https://www.antyradio.pl/News/Najlepsze-strony-erotyczne-w-Polsce-ranking-uzytkowniczek-i-uzytkownikow-20442",
		linkName:
			"Najlepsze strony erotyczne w Polsce - ranking użytkowniczek i użytkowników",
		data: "15.02.2018",
		author: "Antyradio",
	},
	{
		quote: "Nie jest to miejsce dla grzecznych dziewczynek (...) wstydliwość i pruderia to słowa obce użytkownikom tego serwisu.",
		link: "https://www.ckm.pl/seks/ostre-randkowanie-w-sieci-jakie-typy-dziewczyn-mozesz-tam-spotkac,21216,1,a.html",
		linkName:
			"Ostre randkowanie w sieci – jakie typy dziewczyn możesz tam spotkać?",
		data: "16.08.2018",
		author: "CKM",
	},
	{
		quote: "A może potrzebujesz w swoim życiu trochę pikanterii i marzysz o przeżyciu ekscytującej przygody? Naprzeciw twoim potrzebom wychodzi Datezone.",
		link: "https://viva.pl/styl-zycia/wirus-samotnosci-jak-wyglada-randkowanie-w-dobie-pandemii-portal-randkowy-datezone-137966-r1",
		linkName:
			"Wirus samotności, czyli jak wygląda randkowanie w dobie pandemii?",
		data: "18.02.2022",
		author: "Viva",
	},
	{
		quote: "Z Datezone możesz liczyć na wszystko: jednorazową przygodę, spełnienie najskrytszych pragnień, urzeczywistnienie najgorętszych fantazji, albo... dłuższy związek.",
		link: "https://polki.pl/zwiazki-i-seks/randki,nie-szukaj-wymowek-to-najlepszy-czas-zeby-kogos-poznac,10442723,artykul.html",
		linkName: "Nie szukaj wymówek. To najlepszy czas, żeby kogoś poznać.",
		data: "22.02.2022",
		author: "Polki",
	},
	{
		quote: "(...) na tej stronie można poznać szalonych ludzi, którzy szukają dobrej zabawy, szalonego seksu, odskoczni od nudy…",
		link: "https://www.fakt.pl/agnieszka-miala-juz-dosc-sluchania-o-tym-ze-powinna-wyjsc-za-maz-i-miec-dzieci/yhs1680",
		linkName:
			"Agnieszka miała już dość słuchania o tym, że powinna wyjść za mąż i mieć dzieci.",
		data: "03.02.2022",
		author: "Fakt",
	},
];

export default aboutUsContent;
